module.exports = __webpack_public_path__ + "img/thridPayBg.e3f04d8d.jpg";